import React from 'react';
import Modal from './Modal';

export default function ConfirmModal({
  title,
  message,
  confirmLabel = 'Confirm',
  danger = false,
  input,
  onConfirm,
  onCancel,
}) {
  const icon = danger ? (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75"
         strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
      <path d="M12 9v4M12 17h.01" />
      <path d="M10.3 3.86l-8.18 14a1.5 1.5 0 001.3 2.14h16.16a1.5 1.5 0 001.3-2.14l-8.18-14a1.5 1.5 0 00-2.6 0z" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75"
         strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 16v-5M12 8h.01" />
    </svg>
  );

  return (
    <Modal
      size="sm"
      title={title}
      subtitle={message}
      onClose={onCancel}
      icon={icon}
      tone={danger ? 'danger' : 'brand'}
      footer={
        <div className="flex gap-2.5 justify-end">
          <button onClick={onCancel} className="btn-secondary px-4 py-2 text-sm">
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className={danger ? 'btn-danger px-4 py-2' : 'btn-primary px-4 py-2 text-sm'}
          >
            {confirmLabel}
          </button>
        </div>
      }
    >
      {input && (
        <div>
          {input.label && <label className="label">{input.label}</label>}
          <input
            className="input"
            placeholder={input.placeholder || ''}
            value={input.value}
            onChange={e => input.onChange(e.target.value)}
            autoFocus
          />
        </div>
      )}
    </Modal>
  );
}
